export default function ({ store, redirect }) {
    //規約に同意していなければログアウトさせる
    if (!store.$auth.user.is_agreed) {
        redirect('/login');
        store.$auth.logout();
    }
}